import type { RowFormat } from 'common/types/scalarSpreadsheet';
import type { CrossReferenceConfig, CrossReferenceRowState } from './types';
import type { InheritedCellFormat } from './utils/extractFormatFromCell';

// A ScalarSpreadsheet column descriptor for the cross-ref popup. The `values`
// map holds per-row data keyed by row alias, matching the column-first pattern
// used elsewhere in the app (see useFundInvestmentSummarySheet).
export interface CrossRefSheetColumn {
  alias: string;
  header: string;
  gridType: 'number' | 'string';
  format?: RowFormat;
  width?: string;
  values: Record<string, unknown>;
}

export interface CrossRefSheetInitialObject {
  cellKey: string;
  inheritedFormat: InheritedCellFormat;
  config: CrossReferenceConfig;
}

export interface CrossRefSheetTableData {
  cellKey: string;
}

export interface CreateCrossReferencePopupSheetParams {
  cellKey: string;
  // Snapshot of store rows captured at enumeration time. The SpreadsheetConfig
  // seeds from this snapshot; after that the sheet's own cells are the live
  // source of truth. reverseParser mirrors edits back to the store.
  initialRows: CrossReferenceRowState[];
  config: CrossReferenceConfig;
  inheritedFormat: InheritedCellFormat;
  // Width of the host cell. Used for the popup's first (value) column so the
  // value column visually aligns with the cell under it. Pass 0 to fall back
  // to a default width.
  parentWidth: number;
}

// Row 0 of rowConfig carries column headers (via hasColTitle + colTitleRow: 0).
export const TITLE_ROW_ALIAS = 'xref_title';
// Data rows are aliased by entry position so column.values[alias] resolves.
export const ENTRY_ROW_ALIAS_PREFIX = 'xref_entry_';
export const entryAlias = (position: number): string => `${ENTRY_ROW_ALIAS_PREFIX}${position}`;
